export class AssertionError extends Error {
	constructor(
		public id: string,
		message: string,
	) {
		super(`[${id}] ${message}`);
	}
}
